// Gestion centralisée des unités (commande / facturation) : forme canonique,
// fusion des doublons de casse/accents et listes partagées entre modules.

const SYMBOLS = { kg: 'kg', g: 'g', l: 'L', ml: 'mL', cl: 'cL' };
const SPECIALS = { piece: 'Pièce', boite: 'Boîte', unite: 'Unité', fut: 'Fût' };

export const unitKey = (u) => String(u || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

// Majuscule à chaque mot ; symboles de mesure (kg, g, L, mL, cL) préservés.
export const canonicalizeUnit = (u) => {
    const raw = String(u || '').trim();
    if (!raw) return raw;
    const key = unitKey(raw);
    if (SYMBOLS[key]) return SYMBOLS[key];
    if (SPECIALS[key]) return SPECIALS[key];
    return raw.split(/\s+/).map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');
};

export const dedupeSortUnits = (list) => {
    const out = [];
    const seen = new Set();
    for (const u of list) {
        const c = canonicalizeUnit(u);
        const k = unitKey(c);
        if (!c || seen.has(k)) continue;
        seen.add(k);
        out.push(c);
    }
    return out.sort((a, b) => a.localeCompare(b, 'fr', { sensitivity: 'base' }));
};

export const BASE_ORDER_UNITS = ['Pièce', 'Carton', 'Pack', 'Lot', 'Palette', 'Sac', 'Bidon', 'Bouteille', 'Boîte', 'Caisse', 'Seau', 'Barquette', 'Unité'];
export const BASE_BILLING_UNITS = ['kg', 'L', 'Pièce', 'Unité', 'g', 'mL', 'Litre', 'Tonne', 'Boîte', 'Barquette'];

// Base + unités personnalisées (localStorage), moins les supprimées — dédupliquées et triées.
export const loadUnits = (customKey, deletedKey, baseUnits) => {
    try {
        const custom = JSON.parse(localStorage.getItem(customKey) || '[]');
        const deleted = new Set((JSON.parse(localStorage.getItem(deletedKey) || '[]')).map(unitKey));
        return dedupeSortUnits([...baseUnits, ...custom]).filter(u => !deleted.has(unitKey(u)));
    } catch (e) {
        return dedupeSortUnits([...baseUnits]);
    }
};

export const saveCustomUnit = (customKey, deletedKey, unit) => {
    try {
        const canon = canonicalizeUnit(unit);
        if (!canon) return;
        const custom = JSON.parse(localStorage.getItem(customKey) || '[]');
        if (!custom.some(u => unitKey(u) === unitKey(canon))) {
            custom.push(canon);
            localStorage.setItem(customKey, JSON.stringify(custom));
        }
        const deleted = JSON.parse(localStorage.getItem(deletedKey) || '[]');
        if (deleted.some(u => unitKey(u) === unitKey(canon))) {
            localStorage.setItem(deletedKey, JSON.stringify(deleted.filter(u => unitKey(u) !== unitKey(canon))));
        }
    } catch (e) { /* localStorage indisponible */ }
};

export const removeUnit = (customKey, deletedKey, unit, baseUnits) => {
    try {
        const k = unitKey(unit);
        const custom = JSON.parse(localStorage.getItem(customKey) || '[]');
        if (custom.some(u => unitKey(u) === k)) {
            localStorage.setItem(customKey, JSON.stringify(custom.filter(u => unitKey(u) !== k)));
        }
        if (baseUnits.some(u => unitKey(u) === k)) {
            const deleted = JSON.parse(localStorage.getItem(deletedKey) || '[]');
            if (!deleted.some(u => unitKey(u) === k)) {
                deleted.push(canonicalizeUnit(unit));
                localStorage.setItem(deletedKey, JSON.stringify(deleted));
            }
        }
        return true;
    } catch (e) { /* localStorage indisponible */ }
    return false;
};
